import Breadcrumbs, { getCrumbs } from '../common/Breadcrumbs';
import LoadingComponent from '../common/Loading';
import Messages from './Messages';
import PromoBox from './PromoBox';
import Section from './Section';
import HTMLDisplay from './formFields/HTMLDisplay';
import { Field } from 'react-final-form';
import { useLocation } from 'react-router';

const DcnzForm = ({
  formData,
  onSubmit,
  submitting,
  lastPage,
  paymentPage,
  pageClickHandler,
  subtitle,
  buttonLabel,
  buttonSubmittingLabel,
}) => {
  const htmlObjects = formData?.page?.htmlObjects || [];
  const sections = formData?.page?.sections || [];
  const pages = formData?.form?.pageCodes || [];

  const location = useLocation();
  const passedBreadCrumbs = location.state?.breadCrumbs || [];
  const currentBreadCrumb = { title: formData?.form?.name, url: location?.pathname };
  const breadCrumbs = getCrumbs(passedBreadCrumbs, currentBreadCrumb, 'DcnzForm');

  return (
    <div className="ContactPage">
      {subtitle && (
        <PromoBox>
          <p className="intro">{subtitle}</p>
        </PromoBox>
      )}

      {paymentPage && (
        <div className="redirecting">
          <LoadingComponent text="Redirecting..." />
        </div>
      )}

      <Breadcrumbs crumbs={breadCrumbs} />

      <div className="container content">
        <Messages />

        <ul className="nav nav-tabs">
          {pages.map((page, index) => {
            if (page.pageState === 'disabled') return null;

            const isActive = page.code === formData.page.code;
            const isDisabled = page.pageState === 'visible';
            const className = `nav-item ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`.trim();

            return (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <li key={index} role="presentation" className={className}>
                <a onClick={() => pageClickHandler(page, isDisabled)} className="nav-link">
                  {page.pageDone && <span className="fa fa-check me-2" title="Done" />}
                  {page.name}
                </a>
              </li>
            );
          })}
        </ul>

        <div className="bg-light-grey">
          <form onSubmit={onSubmit} className="form-max-width">
            <Field name="sessionId" component="input" type="hidden" />
            <Field name="formType" component="input" type="hidden" />
            <Field name="formId" component="input" type="hidden" />
            <Field name="formPage" component="input" type="hidden" />

            {htmlObjects.map((htmlObject, index) => (
              <HTMLDisplay
                // eslint-disable-next-line @eslint-react/no-array-index-key
                key={index}
                value={htmlObject.value}
                code={htmlObject.code}
                cssClass={htmlObject.cssClass}
                breadCrumbs={breadCrumbs}
              />
            ))}

            {sections.map((section, index) => (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <Section key={index} data={section} breadCrumbs={breadCrumbs} />
            ))}

            <Messages />

            {!lastPage && !paymentPage && (
              <div className="Actions">
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                  {submitting ? buttonSubmittingLabel : buttonLabel}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default DcnzForm;
